module.exports = __webpack_public_path__ + "img/jydt-1.787536fd.png";